let _ = require('../_.js');
let $ = jQuery;

import pipHTML from './auctioncast-pip.html?raw';

_.AuctionCast_AuctionCast_Pip = class AuctionCast_AuctionCast_Pip {

    static is_pip = false;

    static async init() {
        let that = _.AuctionCast_AuctionCast_Pip;

        $("body").append(pipHTML.replace(/__PLUGIN__/g, _.plugin_base_url()));

        // Register ui operation callbacks handled in this class
        _.AuctionCast_AuctionCast.on_auctioncast_ui_operation(that.handle_auctioncast_ui_operation);
        _.AuctionCast_AuctionCast.on_auctioncast_state_change(that.handle_auctioncast_state_change);

        _.on_ui_update_always(null, function () {
            if (_.AuctionCast_AuctionCast.is_this_auction) {
                $(".pip-container").addClass('pip-container-page-is-the-auction');
            } else {
                $(".pip-container").removeClass('pip-container-page-is-the-auction');
            }

            if ($("#chatbox").is(":visible") && !$(".pip-container").hasClass('pip-player-chatbox-open')) {
                $(".pip-container").addClass('pip-player-chatbox-open');
                _.ui_update();
            }

            if (!$("#chatbox").is(":visible") && $(".pip-container").hasClass('pip-player-chatbox-open')) {
                $(".pip-container").removeClass('pip-player-chatbox-open');
                _.ui_update();
            }

            if (($(window).height() < 600 || $(window).width() < 700)) {
                $(".pip-container").addClass('pip-player-mobile');
                $("#auctioncast_player_element").addClass('ac-player-is-pip-mobile');
            } else {
                $(".pip-container").removeClass('pip-player-mobile');
                $("#auctioncast_player_element").removeClass('ac-player-is-pip-mobile');
            }

            if ($(".pip-container").is(":visible")) {
                $("#auctioncast_player_element").addClass('ac-player-is-pip');
            } else {
                $("#auctioncast_player_element").removeClass('ac-player-is-pip');
            }

            if ($(".ac-btn-action-chat").is(':visible')) {
                $(".pip-container").addClass('pip-player-has-chatbox-link');
            } else {
                $(".pip-container").removeClass('pip-player-has-chatbox-link');
            }
        });

        // Listen for frame messages
        _.AuctionCast_AuctionCast.on_receive_message_auctioncast_player_frame(that.handle_receive_message_auctioncast_player_frame);

        // Clicking anywhere on this thing is a click.
        $(".pip-container").click(that.handle_pip_clicked);
    }

    static async handle_auctioncast_ui_operation(operation) {
        let that = _.AuctionCast_AuctionCast_Pip;

        let $player_container = $('.auctioncast-video-container');

        switch (operation) {
            case _.AuctionCast_AuctionCast.OPERATION_SHOW_MAIN_PLAYER:
            case _.AuctionCast_AuctionCast.OPERATION_TRANSITION_PIP_TO_MAIN_PLAYER:
                console.log("Hide pip")
                that.is_pip = false;

                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_show_mute_button');
                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_should_unmute');
                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_hide');

                $(".pip-container").hide();
                $player_container.removeClass('ac-player-is-pip');
                break;

            case _.AuctionCast_AuctionCast.OPERATION_SHOW_PIP_PLAYER:
            case _.AuctionCast_AuctionCast.OPERATION_TRANSITION_MAIN_TO_PIP_PLAYER:
                console.log("Show pip")
                that.is_pip = true;

                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_hide_mute_button');
                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_should_not_unmute');
                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_show');

                $(".pip-container").show();
                $player_container.addClass('ac-player-is-pip');
                $("#auctioncast_player_element").addClass('ac-player-is-pip');
                if (_.AuctionCast_AuctionCast.is_this_auction) {
                    $("#auctioncast_player_element").addClass('ac-player-is-pip-this-auction');
                }
                _.AuctionCast_AuctionCast.set_player_target_element($(".pip-container .pip-player"), true);
                $("#auctioncast_player_element").removeClass('ac-player-is-pip');

                // Lookup auction name
                try {
                    let auction = await App_Models_Auction.get(_.AuctionCast_AuctionCast.status_data.auction_id);
                    let property = await auction.property.fetch();
                    $("#pip-auction-title").text(property.title);
                    $("#pip-auction-title").url = auction.frontendUrl;
                } catch (e) {
                    console.error(e);
                }
                break;

        }
    }

    static async handle_auctioncast_state_change(old_state, new_state) {
        switch (new_state) {
            case _.AuctionCast_AuctionCast.STATE_STANDBY_PIP:
                $(".pip-container").hide();
                break;

            case _.AuctionCast_AuctionCast.STATE_LIVE_PIP:
                $(".pip-container").show();
                break;

            case _.AuctionCast_AuctionCast.STATE_OFFLINE:
                $(".pip-container").hide();
                break;
        }
    }

    // Helper to gracefully scroll the player into view if we clicked on pip
    static scroll_to_big_auctioncast_gallery_player() {
        // Function to check if element is fully visible in the viewport
        function isElementFullyVisible($el) {
            var win = $(window);
            var viewport = {
                top: win.scrollTop(),
                bottom: win.scrollTop() + win.height()
            };

            var bounds = $el.offset();
            bounds.bottom = bounds.top + $el.outerHeight();

            return (!(viewport.bottom < bounds.bottom || viewport.top > bounds.top));
        }

        // Scroll logic
        function scrollToElement($el) {
            if (!isElementFullyVisible($el)) {
                if ($el.offset().top < $(window).scrollTop()) {
                    // If element would be completely visible if we were scrolled to the top, then scroll to the top
                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                } else {
                    // Otherwise, scroll such that the page scroll is 20px above the element
                    $('html, body').animate({ scrollTop: $el.offset().top - 20 }, 'slow');
                }
            }
        }

        // Check for the element and perform the operation
        var $auctioncastContainer = $(".ac-gallery-auctioncast-container");
        if ($auctioncastContainer.length) {
            scrollToElement($auctioncastContainer);
        }
    }

    static async handle_receive_message_auctioncast_player_frame(message) {
        let that = _.AuctionCast_AuctionCast_Pip;

        if (message == 'auctioncast_overlay_clicked') {
            if (that.is_pip) {
                that.handle_pip_clicked();
            }
        }

        if (message == 'auctioncast_player_ready') {
            if (that.is_pip) {
                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_hide_mute_button');
                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_should_not_unmute');
                _.AuctionCast_AuctionCast.send_message_player_frame('overlay_show');
            }
        }
    }

    static async handle_pip_clicked() {
        let that = _.AuctionCast_AuctionCast_Pip;
        if (_.AuctionCast_AuctionCast.is_this_auction) {
            _.ac_show_gallery_type('auctioncast');
            _.AuctionCast_AuctionCast_Pip.scroll_to_big_auctioncast_gallery_player();
        } else {
            try {
                let auction = await App_Models_Auction.get(_.AuctionCast_AuctionCast.status_data.auction_id);
                let url = auction.frontendUrl;
                window.location.href = url;
            } catch (e) {
                console.error(e);
            }
        }
    }
}